
/**
 * Base class for all types of vertices in the dependency graph
 */
export class Vertex {
}
